import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '#configuration/tokenHandling/prepareHeaders.ts';

export const TAGS = {
    TOURSERVICE: 'TOURSERVICE',
};
const customFetchBaseQuery = fetchBaseQuery({
    baseUrl: import.meta.env.VITE_TOUR_SERVICE_API,
    mode: 'cors',
    prepareHeaders,
});

export const apiTourService = createApi({
    tagTypes: Object.keys(TAGS),
    reducerPath: 'apiTourservice',
    baseQuery: customFetchBaseQuery,
    endpoints: () => ({}),
});
